import { deleteUser } from './states';

export const services = {
  deleteUser,
};
